import cloneDeep from 'lodash.clonedeep'
import {
  FETCH_SPECIAL_OFFERS_CREATOR_REQUEST,
  FETCH_SPECIAL_OFFERS_CREATOR_SUCCESS,
  FETCH_SPECIAL_OFFERS_CREATOR_FAILURE,
  UPDATE_SELECTED_PRODUCTS
} from '../../actionTypes/specialOffersCreatorActionTypes'

const initialState = {
  data: {},
  meta: {}
}

const buildRequestState = oldState => {
  const { meta: oldMeta = {} } = oldState

  const newState = {
    ...oldState,
    meta: {
      ...oldMeta,
      errorCode: null,
      errorDetail: '',
      requestDone: false
    }
  }
  return newState
}

const buildSuccessState = (oldState, payload) => {
  const { data } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      ...data
    },
    meta: {
      ...oldMeta,
      errorCode: null,
      errorDetail: '',
      requestDone: true
    }
  }
  return newState
}

const buildFailureState = (oldState, payload) => {
  const { data, errorDetail, errorCode } = payload
  const { data: oldData = {}, meta: oldMeta = {} } = oldState
  const newState = {
    ...oldState,
    data: {
      ...oldData,
      ...data
    },
    meta: {
      ...oldMeta,
      errorCode,
      errorDetail,
      requestDone: true
    }
  }
  return newState
}

const updateSeletedProducts = (oldState, payload) => {
  const newState = cloneDeep(oldState)
  if (oldState.data.selectedProducts[payload.index]) {
    newState.data.selectedProducts[payload.index] = payload.partNumber
  } else {
    newState.data.selectedProducts.push(payload.partNumber)
  }
  return newState
}

const specialOffersCreatorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_SPECIAL_OFFERS_CREATOR_REQUEST:
      return buildRequestState(state)
    case FETCH_SPECIAL_OFFERS_CREATOR_SUCCESS:
      return buildSuccessState(state, payload)
    case FETCH_SPECIAL_OFFERS_CREATOR_FAILURE:
      return buildFailureState(state, payload)
    case UPDATE_SELECTED_PRODUCTS:
      return updateSeletedProducts(state, payload)
    default:
      return state
  }
}

export { initialState, specialOffersCreatorReducer }
